import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstance8t6iqcjia1rj as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.t5m_1.s4(plugin.m3()))
    return Unit_instance;
  var tmp0 = $this.t5m_1;
  var tmp2 = plugin.m3();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.y5l_1.p4r(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.b5m_1.u5m_1.u4(plugin.m3()));
    var pluginData = plugin.x5n(config);
    plugin.y5n(pluginData, scope);
    attributes.m4r(plugin.m3(), pluginData);
    return Unit_instance;
  };
  tmp0.x4(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.t5m_1 = LinkedHashMap().ec();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.u5m_1 = LinkedHashMap().ec();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.v5m_1 = LinkedHashMap().ec();
        var tmp_2 = this;
        tmp_2.w5m_1 = HttpClientConfig$engineConfig$lambda;
        this.x5m_1 = true;
        this.y5m_1 = true;
        this.z5m_1 = false;
        this.a5n_1 = PlatformUtils_getInstance().l4t_1;
      }
      z5n(plugin, configure) {
        var previousConfigBlock = this.u5m_1.u4(plugin.m3());
        var tmp0 = this.u5m_1;
        var tmp2 = plugin.m3();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.x4(tmp2, value);
        installPlugin(this, plugin);
      }
      b5n(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.z5n(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.z5n.call(this, plugin, configure);
        }
        return tmp_0;
      }
      c5n(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.v5m_1.x4(key, block);
      }
      n5m(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.t5m_1.w4().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.v5m_1.w4().p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element_0 = _iterator__ex2g4s_0.r1();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      d5n(other) {
        this.x5m_1 = other.x5m_1;
        this.y5m_1 = other.y5m_1;
        this.z5m_1 = other.z5m_1;
        var tmp0 = this.t5m_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.t5m_1;
        tmp0.z4(map);
        var tmp0_0 = this.u5m_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.u5m_1;
        tmp0_0.z4(map_0);
        var tmp0_1 = this.v5m_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.v5m_1;
        tmp0_1.z4(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
